import type { contrats as Fr } from '../fr/contrats';

/** « contrats » in English — typed on the French: a missing sentence does not compile. */
export const contrats: typeof Fr = {
  filtres: { actif: 'Active', clos: 'Completed', resilie: 'Terminated', tous: 'All' },
  titre: 'Rental agreements',
  sousTitre: 'All your signed rental agreements · find one and reprint it',
  recherche: 'Agreement no., customer, make or plate…',
  aucunCorrespond: 'No agreement matches',
  aucunIci: 'No agreements here',
  essayez: 'Try the plate or the customer name, or change the filter.',
  explication: 'A rental agreement is issued from the rental file, at check-out. Change the filter to see completed agreements.',
  resteDu: (m: string) => `Balance due ${m}`,
  solde: (m: string) => `Paid in full · ${m}`,
  imprimerContrat: 'Print the agreement',
  colNumero: 'Agreement no.', colDate: 'Date', colClient: 'Customer', colVehicule: 'Vehicle',
  colTotal: 'Total', colResteDu: 'Balance due', colStatut: 'Status',
  imprimer: 'Print',
  pied: (n: number, total: number | null) =>
    `${n} ${n === 1 ? 'agreement' : 'agreements'} shown${total !== null ? ` out of ${total}` : ''}. A printed agreement is identical to the original, even months later — it cannot be altered.`,
};
